import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useSearchParams, useParams } from 'react-router-dom';
import { FullPage, LoadingPage } from '@core/ui';
import { ErrorDisplay } from '../features/error-flow';
import { oryService } from '../core/ory/ory-service';
export function ErrorPage() {
    const [searchParams] = useSearchParams();
    const params = useParams();
    // Ory error ID from query param (when Kratos redirects to error UI)
    const oryErrorId = searchParams.get('id');
    const [oryError, setOryError] = useState(null);
    const [isLoading, setIsLoading] = useState(!!oryErrorId);
    // Fetch Ory error details when ID is present
    useEffect(() => {
        if (oryErrorId) {
            setIsLoading(true);
            oryService.getFlowError(oryErrorId)
                .then(error => {
                setOryError(error);
            })
                .finally(() => {
                setIsLoading(false);
            });
        }
    }, [oryErrorId]);
    const errorTypeParam = params.errorType || searchParams.get('type') || 'generic';
    const errorMessage = searchParams.get('message');
    const mapToErrorType = (typeStr) => {
        const normalized = typeStr.replace(/-/g, '_');
        switch (normalized) {
            case 'invalid_invitation':
            case 'invalid_recovery':
            case 'invalid_link':
                return 'invalid_link';
            case 'session_expired':
            case 'session_timeout':
                return 'session_expired';
            case 'network':
            case 'network_error':
                return 'network';
            case 'rate_limit':
                return 'rate_limit';
            case 'access_denied':
                return 'permission_denied';
            default:
                return 'generic';
        }
    };
    // Map Ory error code to ErrorType
    const mapOryCodeToErrorType = (code) => {
        switch (code) {
            case 401:
                return 'session_expired';
            case 403:
                return 'permission_denied';
            case 404:
                return 'invalid_link';
            case 429:
                return 'rate_limit';
            case 500:
            case 502:
            case 503:
            default:
                return 'generic';
        }
    };
    if (isLoading) {
        return _jsx(LoadingPage, { text: "Loading..." });
    }
    // If we have an Ory error, display it
    if (oryError) {
        const oryErrorType = mapOryCodeToErrorType(oryError.error.code);
        const oryErrorMessage = oryError.error.reason || oryError.error.message;
        return (_jsx(FullPage, { stateHolder: true, fillViewport: true, children: _jsx(ErrorDisplay, { type: oryErrorType, customMessage: {
                    title: oryError.error.status || `Error ${oryError.error.code}`,
                    message: oryErrorMessage
                }, onAction: () => window.location.href = '/auth/login', variant: "ghost" }) }));
    }
    // Fallback to type/message based error display
    const errorType = mapToErrorType(errorTypeParam);
    return (_jsx(FullPage, { stateHolder: true, fillViewport: true, children: _jsx(ErrorDisplay, { type: errorType, customMessage: errorMessage ? { message: errorMessage } : undefined, onAction: () => window.location.href = '/auth/login', variant: "ghost" }) }));
}
